import { Injectable, signal } from '@angular/core'

@Injectable()
export class ErrorCenterService {
  readonly errors = signal<unknown[]>([])

  /**
   * Fügt einen neuen Fehler hinzu und behält maximal 100 Fehler
   * @param error Error Object
   */
  addError(error: unknown) {
    this.errors.update((errors) => [error, ...errors].slice(0, 100))
  }
}
